import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import CurrencyService from '../../../../Services/CurrencyService';

export default class CurrencySelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    showSelectFilterAt: 10,
    IsCheckBoxEnabled: false,
    onlyActive: false,
    selectValues: [],
    editedItem: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.onlyActive !== this.props.onlyActive ||
      JSON.stringify(prevProps.selectValues) !== JSON.stringify(this.props.selectValues)
    ) {
      this.populateListData();
    }
  }

  populateListData() {
    CurrencyService.GetCurrencyList()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((currency) => {
          if (
            (!this.props.onlyActive || currency.isActive) &&
            (!this.props.selectValues ||
              this.props.selectValues.length === 0 ||
              this.props.selectValues.some((x) => x.toString() === currency.currencyId.toString()))
          ) {
            optValues.push({
              label: `${currency.code} (${currency.description})`,
              value: currency.currencyId,
              disabled: false,
            });
          }
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('CUS52');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        selectValues={this.state.selectValues}
        filterCleared={this.props.filterCleared}
        showSelectFilterAt={this.props.showSelectFilterAt}
        IsCheckBoxEnabled={this.props.IsCheckBoxEnabled}
        editedItem={this.props.editedItem}
      />
    );
  }
}
